module.exports = __webpack_public_path__ + "img/guide-header.8ac2a72.png";